import { render, staticRenderFns } from "./dailyBox.vue?vue&type=template&id=028bb337&scoped=true&"
import script from "./dailyBox.vue?vue&type=script&lang=js&"
export * from "./dailyBox.vue?vue&type=script&lang=js&"
import style0 from "./dailyBox.vue?vue&type=style&index=0&id=028bb337&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bb337",
  null
  
)

export default component.exports